import { render, staticRenderFns } from "./camera_qd.vue?vue&type=template&id=ef06bc02&scoped=true&"
import script from "./camera_qd.vue?vue&type=script&lang=js&"
export * from "./camera_qd.vue?vue&type=script&lang=js&"
import style0 from "./camera_qd.vue?vue&type=style&index=0&id=ef06bc02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef06bc02",
  null
  
)

export default component.exports